/**
 * Helpers for connected-record navigation. All routes here already exist in App.js.
 * These build hrefs and resolve/serialize the customer-detail `?tab=` query param.
 */

/**
 * Build an app route for a related record. Returns `null` when the id is missing so
 * callers can omit the link (and render plain text) instead of linking nowhere.
 */
export function recordHref(kind, id, options = {}) {
  if (!id) return null;
  const tab = options.tab ? `?tab=${encodeURIComponent(options.tab)}` : '';
  switch (kind) {
    case 'customer':
      return `/customers/${id}${tab}`;
    case 'ticket':
      return `/tickets/${id}`;
    case 'asset':
      return `/assets/${id}`;
    default:
      return null;
  }
}

/** Return `raw` only if it is one of `allowed`, otherwise `fallback`. */
export function resolveTab(raw, allowed, fallback = 'overview') {
  if (raw && Array.isArray(allowed) && allowed.includes(raw)) return raw;
  return fallback;
}

/**
 * Return a URLSearchParams with `tab` set to the given value (removed when it equals the
 * default), preserving every other existing query param. Accepts a string or
 * URLSearchParams for `current`.
 */
export function buildTabSearch(current, tab, defaultTab = 'overview') {
  const next = new URLSearchParams(current);
  if (!tab || tab === defaultTab) next.delete('tab');
  else next.set('tab', tab);
  return next;
}
